export namespace Dashboard {
    export interface DashboardComponentPropsBase<ReportOptionsT = null> {
        id?: string;
        reportOptions?: ReportOptionsT;
        reportMode?: boolean
        stateCb?: (res: DashboardComponentState) => void
    }

    export interface IComponentTimed {
        referenceTime?: string;
    }
}

type DashboardComponentLoadingState =  {
    state: "loading";
    id: string;
}

type DashboardComponentErrorState = {
    state: "error";
    error: string;
    id: string;
}

type DashboardComponentFinishedState = {
    "state": "finished"
    id: string;
}

export type DashboardComponentState =
    DashboardComponentFinishedState
    | DashboardComponentLoadingState
    | DashboardComponentErrorState
